import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c9f7617"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-page" }
const _hoisted_2 = { class: "content-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Illustration = _resolveComponent("Illustration")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.infoStatus === 'isNotSignIn')
        ? (_openBlock(), _createBlock(_component_Illustration, {
            key: 0,
            class: "pic",
            illustrationsUrl: "static/icons-pack.svg",
            name: "started",
            width: "216",
            height: "175"
          }))
        : _createCommentVNode("", true),
      (_ctx.infoStatus !== 'isNotSignIn')
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 1,
            class: "icon-status",
            height: "40",
            width: "40",
            name: _ctx.infoStatus === 'transferredCall' ? 'ic24-success-fill' : 'ic24-info-fill',
            color: _ctx.infoStatus === 'transferredCall' ? '--sui-green-500' : '--sui-blue-500'
          }, null, 8, ["name", "color"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Typography, {
        class: _normalizeClass(["title", _ctx.getTitleClass])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t(`${_ctx.infoStatus}.title`)), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_Typography, {
        class: _normalizeClass(["description", _ctx.getDescriptionClass])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t(`${_ctx.infoStatus}.description`, { callNumberFrom: `${_ctx.lastTransferredCallNumbers.number1}`,callNumberTo: `${_ctx.lastTransferredCallNumbers.number2}`,})), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_Button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeInfoStatus(_ctx.infoStatus)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t(`${_ctx.infoStatus}.button`)), 1)
        ]),
        _: 1
      })
    ])
  ]))
}